var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64941 27.4697V27.9697C5.64911 32.7765 7.20402 37.4553 10.082 41.3076C12.96 45.1598 17.007 47.9802 21.6201 49.3477C26.2334 50.7152 31.1659 50.5562 35.6816 48.8955C39.9037 47.3427 43.5501 44.5544 46.1514 40.9053H35.7686V35.7598H53.3652V53.3398H48.2158V46.543C44.7121 50.3603 40.1925 53.1179 35.1719 54.4805C29.7183 55.9605 23.9403 55.7241 18.626 53.8037C13.3117 51.8833 8.71935 48.3721 5.47559 43.749C2.23185 39.1259 0.494231 33.6155 0.5 27.9697L0.500977 27.4697H5.64941ZM20.7686 1.45996C26.2222 -0.0200718 32.0002 0.216314 37.3145 2.13672C42.6287 4.05717 47.2211 7.56829 50.4648 12.1914C53.7085 16.8146 55.4463 22.3249 55.4404 27.9707L55.4395 28.4697H50.291V27.9697C50.2913 23.1631 48.7363 18.4851 45.8584 14.6328C42.9805 10.7806 38.9334 7.96034 34.3203 6.59277C29.7071 5.22528 24.7745 5.38329 20.2588 7.04395C16.0364 8.59678 12.3895 11.3856 9.78809 15.0352H20.1719V20.1797H2.57422V2.60059H7.72363V9.39746C11.2274 5.5798 15.7477 2.82259 20.7686 1.45996Z",
    fill: "#077CA5",
    stroke: "#077CA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewIcon);
export default __webpack_public_path__ + "static/media/ReviewIcon.ba3b7c4602f1874c0cc033571244f63a.svg";
export { ForwardRef as ReactComponent };